export type SaleOrderNameSource = {
  name?: string | null;
};

export type SaleOrderNavigationSource = SaleOrderNameSource & {
  budgetCode?: string | null;
};

export function resolveSaleOrderName(
  saleOrder: SaleOrderNameSource | null | undefined,
): string {
  const name = saleOrder?.name;

  return name?.trim() ? name : '-';
}

export function resolveSaleOrderNavigationReference(
  saleOrder: SaleOrderNavigationSource | null | undefined,
): string {
  return composeSaleOrderReference(saleOrder, ' # ');
}

export function resolveSaleOrderPdfTitle(
  saleOrder: SaleOrderNavigationSource | null | undefined,
): string {
  return composeSaleOrderReference(saleOrder, ' - ');
}

function composeSaleOrderReference(
  saleOrder: SaleOrderNavigationSource | null | undefined,
  separator: ' # ' | ' - ',
): string {
  const name = normalizeReferencePart(saleOrder?.name);
  const budgetCode = normalizeReferencePart(saleOrder?.budgetCode);

  if (!name) return budgetCode || '-';
  if (!budgetCode) return name;

  const nameWithoutCode = removeTerminalBudgetCode(name, budgetCode);
  return nameWithoutCode
    ? `${nameWithoutCode}${separator}${budgetCode}`
    : budgetCode;
}

function removeTerminalBudgetCode(name: string, budgetCode: string): string {
  for (const suffix of [` # ${budgetCode}`, ` - ${budgetCode}`]) {
    if (name.endsWith(suffix)) {
      return name.slice(0, -suffix.length).trim();
    }
  }

  return name === budgetCode ? '' : name;
}

function normalizeReferencePart(value: string | null | undefined): string {
  const normalized = (value || '').trim();
  return normalized === '-' ? '' : normalized;
}
